import { render, staticRenderFns } from "./Composer.vue?vue&type=template&id=432a54fe&scoped=true&"
import script from "./Composer.vue?vue&type=script&lang=js&"
export * from "./Composer.vue?vue&type=script&lang=js&"
import style0 from "./Composer.vue?vue&type=style&index=0&id=432a54fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432a54fe",
  null
  
)

export default component.exports